import { Flashbar } from '@amzn/awsui-components-react';
import React, { useContext, ReactElement } from 'react';
import { NotificationContext } from './NotificationProvider';
import { NotificationContextType } from './types';

/**
 * custom hook to use notification context
 */
export function useNotification(): NotificationContextType {
  const { items, addNotification, removeNotification, clearByGroup } = useContext(
    NotificationContext
  );
  return { items, addNotification, removeNotification, clearByGroup };
}

/**
 * component to display flashbar notification in the notification area
 * of Polaris AppLayout
 */
export function Notification(): ReactElement {
  const { items } = useNotification();
  return (
    <>
      {items.map((item) => (
        <Flashbar key={item.id} items={[item]} />
      ))}
    </>
  );
}
